import ApiTableList from "../../ApiKeysTable";

type Props = {
  subAccountId: string;
  handleCopy: (v: string) => void;
};

const APISection = ({ subAccountId, handleCopy }: Props) => (
  <ApiTableList handleCopy={handleCopy} subAccountId={subAccountId} />
);

export default APISection;
